module.exports = __webpack_public_path__ + "sprites@2x.9488.png";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/sprites@2x.png
// module id = ./src/_asset/sources/assets/images/sprites@2x.png
// module chunks = main